import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import Users from './Users';
import moment from 'moment';

// ref: https://developer.paypal.com/docs/classic/paypal-payments-standard/integration-guide/Appx_websitestandard_htmlvariables/#technical-variables
const sandbox = false;

/** Production Postback URL */
const PRODUCTION_VERIFY_URI = 'https://www.paypal.com/cgi-bin/webscr';
const PRODUCTION_BUSINESS = 'patrick.poulin@gmail.com';

/** Sandbox Postback URL */
const SANDBOX_VERIFY_URI = 'http://www.sandbox.paypal.com/cgi-bin/webscr';
const SANDBOX_BUSINESS = 'patrick.poulin-facilitator@gmail.com';
// paypal sandbox client: patrick.poulin-buyer@gmail.com
// all same password then regular paypal account

const LOCALHOST_URL_PREFIX = 'http://localhost:3000/';
const PRODUCTION_URL_PREFIX = 'http://statelo.com/';

const RETURN_URL = 'userAccount';
const CANCEL_RETURN_URL = 'userAccount';
const IPN_LISTENER_URL = 'api/ipnpaypal';

class UserAccount extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			profile: this.props.auth.getProfile(),
			isAuthenticated: this.props.auth.isAuthenticated(),

			user: {
				playerId: '0',
				playerName: '',
				streetaddress: '',
				addresslevel1: '',
				addresslevel2: '',
				postalcode: '',
				country: '',
				tel: '',
				email: '',
				memberActive: false,
				memberDateExpiration: '',
				userUpdatedProfile: false,
				statsPlayerName: ''
			},

			players: [],
			expDelay: 0,
			loading: true,
			showSubscriptionPanel: false,
			showMemberPanel: true,		// default true
			urlPrefix: '',

			reference: ''
		};
	
		this.clickSaveInsc = this.clickSaveInsc.bind(this);
		this.clickSaveInsc01 = this.clickSaveInsc01.bind(this);
		this.clickSaveInsc02 = this.clickSaveInsc02.bind(this);
	}

	componentDidMount() {
		// console.log('UserAccount: componentDidMount');

		// Get playerId and info
		var _this = this;
		var profile = this.state.profile;

		// console.log(profile);

		// Debug - user another authUserId
		var authUserId = profile.user_id;

		var urlPrefix = PRODUCTION_URL_PREFIX;
		if(window.location.href.indexOf('localhost') !== -1) {
			urlPrefix = LOCALHOST_URL_PREFIX;
		}
		this.setState({
			urlPrefix: urlPrefix
		});

		if (authUserId !== undefined) {
			Users.getUserInfo(authUserId, function(user) {
				user.authUserId = profile.user_id;

				// user statistic profle (playerId and name)
	      Axios.get('/api/players/playerid/' + user.playerId).then(function (respPlayer) {

					if(user.playerId.toString() !== '0') {
						user.statsPlayerName = respPlayer.data.firstname + ' ' + respPlayer.data.lastname;
					} else {
						user.statsPlayerName = 'À DÉTERMINER'
					}

					_this.setState({
						user: user,
						expDelay: user.expDelay,
						loading: false
					});
				});
			});
		}
	}

	render() {
		//console.log('UserAccount: render')
		var profile = this.state.profile;
		var user = this.state.user;
	
		// console.log('this.state.urlPrefix: ' + this.state.urlPrefix);
		// console.log(user);
		return (
			<div className="animated fadeIn">
				{this.displayModule()}
			</div>
		);
	}
	
	displayModule() {
		var profile = this.state.profile;
		var user = this.state.user;

		if (!this.state.isAuthenticated) {
			return (
				<div>
		      <h5>Votre Compte</h5>
					<p>Vous devez vous connecter pour visualiser votre compte ou vous abonner.<br/>
					Cliquez sur <b>Se connecter</b> dans la barre de gauche.<br/></p>
				</div>
			);

		} else {
			return (
				<div>
				<div className="row">
					<div className="col-md-4">
						<h5>{this.state.user.playerName}</h5>
					</div>
					<div className="col-md-6">
		        <h5>Votre Compte</h5>
					</div>

					<div className="col-md-1">
						<img className="img-circle" src={profile.picture} />
					</div>
	       </div>
				<hr/>

				<div className="row">
				<div className="col-md-12">
					{this.displayProfile(user)}
				</div>
				</div>
				</div>
			)
		}
	}

	displayProfile(user) {
		if (this.state.loading) {
			return ( this.displaySpinner() );
		} else {
			return ( this.displayData(user) );
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	// https://www.w3schools.com/tags/att_form_autocomplete.asp
	// https://developers.google.com/web/fundamentals/design-and-ux/input/forms/#recommended_input_name_and_autocomplete_attribute_values
	displayData(user) {
		return (
			<div className="row">
				<div className="col-md-4">
					<h5>Informations utilisateur</h5><br/>
					<p>Nom: {user.name}</p>
					<p>Adresse: {user.streetaddress}</p>
					<p>Ville: {user.addresslevel2}</p>
					<p>Province / État: {user.addresslevel1}</p>
					<p>Code postal: {user.postalcode}</p>
					<p>Pays: {user.country}</p>
					<p>Courriel: {user.email}</p>
					<p>Téléphone: {user.tel}</p>
					<p><b>Profil statistique: {user.statsPlayerName}</b></p>
					<Link to='/profile' className="btn btn-primary"> Modifier votre profil </Link>
					<hr/>
				</div>

				<div className="col-md-8">
					{this.state.showMemberPanel ? this.dispMemberPanel(user) : null}
				</div>
				<br/>
			</div>
		);
	}

	dispMemberPanel(user) {
		return (
			<div className="row">
			<div className="col-md-12">
				<h5>Abonnement au Tableau de Bord</h5><br/>
				{user.memberActive ? this.dispMemberDiv(user) : this.dispNonMemberDiv()}
			</div>
			</div>				
		);
	}

	dispMemberDiv(user) {
		var expDelayClassStr = '';
		if (this.state.expDelay <= 14) {
			expDelayClassStr = 'exp-delay-expiring';
		}

		return (
			<div className="form-group">
				<div className="row">
				<div className="col-md-8 text-center">
					<p className="form-control member-box member-active" id="memberActive"> Vous êtes membre ! </p>
				</div>
				</div>
					
				<div className="row">
				<div className="col-md-12">
					<br/>
					<span className={expDelayClassStr}> Expiration de votre abonnement: {moment(user.memberDateExpiration).format('YYYY-MM-DD')} </span> <br/>
					<span className={"font-italic " + expDelayClassStr}> (Jours restants: {this.state.expDelay}) </span>
				</div>
				</div>
				<br/>

				{this.dispRenew()}
			</div>
		);
	}

	dispNonMemberDiv() {
		return (
			<div className="form-group">
				<div className="row">
				<div className="col-md-8 text-center">
					<p className="form-control member-box member-inactive" id="memberActive"> Vous n'êtes pas membre &nbsp;:-( </p>
				</div>
				</div>
  			<br/>

				<div className="row">
				<div className="col-md-12">
					<p> Abonnez-vous simplement et profitez de statistiques avancées très intéressantes ! </p>
					<img className="img-fluid" src="./img/regulier-aut-2019-banner.png" alt="abonnement-annuel" width="600"/>
   				<br/><br/>
				</div>
				</div>

				{this.dispSubsPanel()}

			</div>
		);
	}

	dispRenew() {
/*
			// Validate profile validity
			if(this.state.user.userUpdatedProfile) {
				this.setState({
					showMemberPanel: false,
					// showSubscriptionPanel: true,
					showOption02Panel: true
				});
			} else {
				alert('Mettre les informations de votre profile à jour avant de renouveller votre abonnement');
			}
*/
	
		//if(this.state.expDelay <= 90) {
		if(true) {
			return(
				<div className="row">
				<div className="col-md-12">

					<p> Renouveller votre abonnement avant qu'il expire. Ce dernier s'ajoutera à votre période actuelle. </p>
					<img className="img-fluid" src="./img/regulier-aut-2019-banner.png" alt="abonnement-annuel" width="600"/>
	    		<br/><br/>

					{this.dispSubsPanel()}

				</div>
				</div>
			);

		} else {

			return(
				<div className="row">
				<div className="col-md-12">
					<br/>
					<p> Renouvellement possible lorsqu'il reste 90 jours et moins à votre abonnement.</p>
				</div>
				</div>
			);
		}
	}

	dispSubsPanel() {
		var urlPrefix = this.state.urlPrefix;
		var userId = this.state.user._id;

		return (
			<div className="row">
			<div className="col-md-12">

				<p>Cliquer sur le bouton suivant pour payer par PayPal ou carte de crédit</p>

				<form action={sandbox ? SANDBOX_VERIFY_URI : PRODUCTION_VERIFY_URI} method='post'>
			    <input type='hidden' name='cmd' value='_xclick'/>
			    <input type='hidden' name='business' value={sandbox ? SANDBOX_BUSINESS : PRODUCTION_BUSINESS}/>
			    <input type='hidden' name='quantity' value='1'/>
			    <input type='hidden' name='item_name' value='Abonnement 12 mois - Régulier'/>
			    <input type='hidden' name='amount' value='49.00'/>
			    <input type='hidden' name='currency_code' value='CAD'/>
			    <input type='hidden' name='item_number' value='AB12M-01R'/>
			    <input type='hidden' name='no_shipping' value='1'/>
			    <input type="hidden" name="lc" value="fr_CA"/>
			    <input type='hidden' name='custom' value={userId}/>
			    <input type='hidden' name='return' value={urlPrefix + RETURN_URL}/>
			    <input type='hidden' name='cancel_return' value={urlPrefix + CANCEL_RETURN_URL}/>
			    <input type='hidden' name='notify_url' value={urlPrefix + IPN_LISTENER_URL}/>                       

  				<button type="submit" className="btn btn-primary" onClick={this.clickSaveInsc02}> Payer avec Paypal ou une carte de crédit</button>
				</form> 
			</div>
			</div>
		);
	}

	clickSaveInsc01() {
		this.clickSaveInsc(0);
	}

	clickSaveInsc02() {
		this.clickSaveInsc(1);
	}

	clickSaveInsc(txType) {
		var userId = this.state.profile.user_id;
		var userName = this.state.profile.name;
		var reference = this.state.reference;
		var typeStr = '';

		if(txType === 0) {
			typeStr = 'Click: Abonnement mensuel';
		} else if (txType === 1) {
			typeStr = 'Click: Abonnement annuel';
		}

		// Log Events from user
		var userEventsObj = {
			date: new Date(),
			type: 'ClickPay',
			userId: userId,
			typeStr: typeStr,
			userName: userName,
			reference: reference,
			sandbox: sandbox
		};

		Axios.post('/api/userEvents/logEvent/', {
			userEventsObj: userEventsObj
		})
		.then(function(response) {
			//console.log(response);
		})
		.catch(function(error) {
			console.log(error);
		});
	}

}

export default UserAccount;

